module.exports = __webpack_public_path__ + "static/media/TRON.667bf652.png";